import axios from 'axios';

const MobileWithValidationService = {
  validateMobile: (endpoint, path, contactDetail) =>
    axios.post(
      `${endpoint}${path}`,
      {
        contactMethod: 'SMS',
        purpose: 'VerifyApplicant',
        contactDetail
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    ),
  validateCode: (endpoint, path, contactDetail, code) =>
    axios.post(
      `${endpoint}${path}`,
      {
        contactMethod: 'SMS',
        purpose: 'VerifyApplicant',
        contactDetail,
        code
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
};

export default MobileWithValidationService;
